<template>
    <v-container
            id="sellers"
            fluid
            tag="section"
    >

        <v-breadcrumbs :items="breadcrumb">
            <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                        :to="item.href"
                        :disabled="item.disabled"
                >
                    {{ item.text.toUpperCase() }}
                </v-breadcrumbs-item>
            </template>
        </v-breadcrumbs>


        <v-data-table
                :options.sync="options"
                :loading="loading"
                :loading-text="$t('global.loading')"
                :items="sellers"
                :server-items-length="totalItems"
                :headers="headers"
                :footer-props="footerProps"
                :no-data-text="$t('global.no_data')"
        >
            <template v-slot:item.address="{ item }">
                <template v-if="item.address.line1">{{item.address.line1}}<br/></template>
                <template v-if="item.address.line2">{{item.address.line2}}<br/></template>
                <template v-if="item.address.state">{{item.address.state}}<br/></template>
                <template v-if="item.address.postal_code">{{item.address.postal_code}}<br/></template>
                <template v-if="item.address.country">{{item.address.country}}</template>
            </template>
            <template v-slot:item.menu="{ item }">
                <v-menu bottom left>
                    <template v-slot:activator="{ on }">
                        <v-btn
                                icon
                                v-on="on"
                        >
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item
                                :to="`sellers/${item.id}`"
                        >
                            <v-list-item-title>{{ $t('sellers.edit_seller') }}</v-list-item-title>
                        </v-list-item>

                    </v-list>
                </v-menu>
            </template>
        </v-data-table>
        <v-fab-transition>
            <v-btn
                    to="sellers/new"
                    color="primary"
                    fab
                    dark
                    small
                    absolute
                    bottom
                    right
            >
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-fab-transition>
    </v-container>
</template>

<script>
    export default {
        name: 'Sellers.List',

        data() {
            return {
                totalItems: 0,
                breadcrumb: [
                    {
                        text: this.$i18n.t('global.stores'),
                        disabled: false,
                        href: '/stores',
                    },
                    {
                        text: this.$i18n.t('global.store'),
                        disabled: false,
                        href: '/stores/' + this.$route.params.store_id,
                    },
                    {
                        text: this.$i18n.t('global.sellers'),
                        disabled: false,
                        href: '/stores/' + this.$route.params.store_id + '/sellers',

                    },
                ],
                loading: false,
                headers: [
                    {text: this.$i18n.t('global.name'), value: 'first_name', sortable: false},
                    {text: this.$i18n.t('global.email'), value: 'email', sortable: false},
                    {text: '', value: 'menu', sortable: false, width: '50px'},
                ],
                footerProps: {'items-per-page-options': [25], 'show-first-last-page': true},
                options: {
                    page: 1,
                    itemsPerPage: 25,
                    sortBy: [],
                    sortDesc: [],
                    groupBy: [],
                    groupDesc: [],
                    multiSort: false,
                    mustSort: false,
                },
                sellers: []
            };
        },

        methods: {
            load() {
                this.loading = true;

                this.$axios.get('sellers?store_id=' + this.$route.params.store_id + '&page=' + this.options.page)
                    .then(response => {
                        this.loading = false;
                        this.sellers = response.data['hydra:member'];
                        this.totalItems = response.data['hydra:totalItems'];
                    });
            }
        },

        watch: {
            options: {
                handler() {
                    this.load();
                },
                deep: true
            }
        },

        computed: {},
    }
</script>
